import s from "./ModalFrame.module.scss";
import { ModalSaveConfig } from "../ModalSaveConfig/ModalSaveConfig";
import { Loader } from "../Loader/Loader";
import { RenderLoader } from "../RenderLoader/RenderLoader";
import { RenderPreview } from "../RenderPreview/RenderPreview";
import { FullScreenPreview } from "../FullScreenPreview/FullScreenPreview";
import { ModalPleaseNote } from "../ModalPleaseNote/ModalPleaseNote";
import { ModalServerOffline } from "../ModalServerOffline/ModalServerOffline";
import { CreateFolderModal } from "../CreateFolderModal/CreateFolderModal";
import { CreatePresetModal } from "../CreatePresetModal/CreatePresetModal";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";
import { getStateModal } from "../../../redux/reducers/app/appSelectors";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { ModalStatusT, NameModals } from "../../../redux/reducers/app/appTypes";
import { handleImage } from "../../api/renderAndLoadImage";
import ResetSceneModal from "../ResetSceneModal/ResetSceneModal";

// Props for camera presets hook
export interface ModalFrameProps {
  savePreset: (customName?: string) => Promise<void>;
  loadPresets: () => Promise<void>;
}

export const ModalFrame = ({ savePreset, loadPresets }: ModalFrameProps) => {
  const dispatch = useAppDispatch();
  const closeFunc = (name: NameModals) => {
    dispatch(changeShowModal({ nameModal: name, stateModal: false }));
  };

  const tutorial: { name: NameModals; data: ModalStatusT } = useAppSelector(
    getStateModal("saveConfig")
  );
  const loader: { name: NameModals; data: ModalStatusT } = useAppSelector(
    getStateModal("loader")
  );

  const glbLoader: { name: NameModals; data: ModalStatusT } = useAppSelector(
    getStateModal("glbLoader")
  );

  const renderLoader: { name: NameModals; data: ModalStatusT } = useAppSelector(
    getStateModal("renderLoader")
  );

  const renderPreview: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("renderPreview"));
  const fullScreenPreview: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("fullScreenPreview"));
  const pleaseNote: { name: NameModals; data: ModalStatusT } = useAppSelector(
    getStateModal("pleaseNote")
  );
  const serverOffline: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("serverOffline"));
  const createFolderModal: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("createFolderModal"));
  const createTemplateModal: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("createTemplateModal"));
  const createPresetModal: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("createPresetModal"));
  const resetSceneModal: { name: NameModals; data: ModalStatusT } =
    useAppSelector(getStateModal("resetScene"));

  return (
    <>
      {tutorial.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <ModalSaveConfig closeFunc={() => closeFunc(tutorial.name)} />
        </div>
      )}
      {loader.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <Loader />
        </div>
      )}
      {glbLoader.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <Loader />
        </div>
      )}
      {renderLoader.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <RenderLoader closeFunc={() => closeFunc(renderLoader.name)} />
        </div>
      )}
      {renderPreview.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <RenderPreview
            closeFunc={() => closeFunc(renderPreview.name)}
            img={renderPreview.data.otherParams.img}
          />
        </div>
      )}
      {fullScreenPreview.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <FullScreenPreview
            imageUrl={fullScreenPreview.data.otherParams.img}
            onClose={() => closeFunc(fullScreenPreview.name)}
            onDownload={() =>
              handleImage({
                base64Image: fullScreenPreview.data.otherParams.img,
                type: "download",
              })
            }
          />
        </div>
      )}
      {pleaseNote.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <ModalPleaseNote closeFunc={() => closeFunc(pleaseNote.name)} />
        </div>
      )}
      {serverOffline.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <ModalServerOffline closeFunc={() => closeFunc(serverOffline.name)} />
        </div>
      )}
      {createFolderModal.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <CreateFolderModal
            closeFunc={() => closeFunc(createFolderModal.name)}
            initialData={createFolderModal.data.otherParams}
          />
        </div>
      )}
      {createTemplateModal.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <CreateFolderModal
            closeFunc={() => closeFunc(createTemplateModal.name)}
            initialData={createTemplateModal.data.otherParams}
          />
        </div>
      )}
      {createPresetModal.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <CreatePresetModal
            closeFunc={() => closeFunc(createPresetModal.name)}
            savePreset={savePreset}
            loadPresets={loadPresets}
          />
        </div>
      )}
      {resetSceneModal.data["isShow"] && (
        <div className={s.modal_bg} style={{ zIndex: 9999 }}>
          <ResetSceneModal closeFunc={() => closeFunc(resetSceneModal.name)} />
        </div>
      )}
    </>
  );
};
